module.exports = __webpack_public_path__ + "static/media/134.6be19b9f.png";